// **** import modules ****
import app, { csl } from "@@assets/scripts/common";
import { Autoplay, EffectFade, Swiper } from 'swiper'
import "swiper/swiper-bundle.css";
Swiper.use([Autoplay, EffectFade])
import "./_topics";

// **** process ****
app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
	
	const swiper = new Swiper(".swiper-container", {
		effect: "fade",
		loop: true,
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
		},
		speed: 1000
	});
	swiper.init();
});

app.exec();
